import AuthoringExperiments from 'bundles/epic/clients/Authoring';
import { PLATFORM_ONLY_ITEM_TYPES } from 'bundles/item-authoring/shared/platformOnlyItemTypes';
import type { ItemType } from 'bundles/item/types/ItemType';

// https://tools.coursera.org/epic/experiment/HJG-kI6uEeyAw9c5depHlw
export const isItemAuthoringFrameworkEnabledForType = (itemType: ItemType): boolean => {
  if (!itemType) {
    return false;
  }

  return (
    AuthoringExperiments.get('enabledItemAuthoringFrameworkTypes').includes?.(itemType) ||
    PLATFORM_ONLY_ITEM_TYPES.includes(itemType)
  );
};

export const isCompareItemVersionsEnabledForType = (itemType?: ItemType): boolean => {
  if (!itemType) {
    return false;
  }

  return AuthoringExperiments.get('enabledCompareItemVersionTypes').includes?.(itemType);
};

// https://tools.coursera.org/epic/experiment/CH1RJ_xEEe666w76OVbGYQ
export const isPluginUpdatedUiEnabled = () => {
  return AuthoringExperiments.get('enablePluginUpdatedUi');
};

// https://tools.coursera.org/epic/experiment/mc7TwyjNEe-BZw7QjuOi1Q
export const isV2PluginItemAuthoringEnabled = () => {
  return AuthoringExperiments.get('enableV2PluginItemAuthoring');
};

// https://tools.coursera.org/epic/experiment/iG7-ZVamEe-USQr_6ZvHVQ
export const isCourseOutlineSummaryExportsEnabled = () => {
  return AuthoringExperiments.get('enableCourseOutlineSummaryExports');
};

// https://tools.coursera.org/epic/experiment/MqmiqHE4Ee-QdhKGhQs4zw
export const isOutlineGenerationFromScratchEnabled = () => {
  return AuthoringExperiments.get('enableOutlineGenerationFromScratch');
};

// https://tools.coursera.org/epic/experiment/awZbpiBLEfC1iRKne8QPDw
// This is a new isOutlineGenerationFromScratchEnabled epic that uses the partnerId for the pilot.
export const isOutlineGenerationFromScratchPilotEnabled = (partnerId?: number): boolean => {
  if (!partnerId && partnerId !== 0) {
    return false;
  }
  // eslint-disable-next-line camelcase
  return AuthoringExperiments.get('enableOutlineGenerationFromScratchPilot', { partner_id: partnerId.toString() });
};

// https://tools.coursera.org/epic/experiment/z3n_v4aWEe-yzhJWa8b7XQ
export const isCoachForAuthorsEnabled = () => {
  return AuthoringExperiments.get('enableCoachForAuthors');
};

// https:// tools.coursera.org/epic/experiment/mlXFx4v3Ee-yzhJWa8b7XQ
export const isCommonCartridgeSmartIngestionEnabled = (partnerId?: number) => {
  return (
    AuthoringExperiments.get('enableCommonCartridgeSmartIngestion') &&
    isOutlineGenerationFromScratchPilotEnabled(partnerId)
  );
};

export const isCbAutoSplitEnabled = (partnerId?: number) => {
  return AuthoringExperiments.get('enableCbAutoSplit') && isOutlineGenerationFromScratchPilotEnabled(partnerId);
};

// https://tools.coursera.org/epic/experiment/l8-MNuTLEe-6kQ5XAizh6w
export const isDescriptIntegrationEnabled = (partnerId?: number) => {
  return AuthoringExperiments.get('enableDescriptIntegration') && isOutlineGenerationFromScratchPilotEnabled(partnerId);
};

export const isDescriptIntegrationForRedirect = () => {
  return AuthoringExperiments.get('enableDescriptIntegration');
};

// https://tools.coursera.org/epic/experiment/Bj6atwZ9EfC1iRKne8QPDw
export const isCourseBuilderNonEnglishSupportEnabled = (partnerId?: number) => {
  return (
    AuthoringExperiments.get('enableCourseBuilderNonEnglishSupport') &&
    isOutlineGenerationFromScratchPilotEnabled(partnerId)
  );
};
